import React, { useCallback } from 'react'
import Select, { components } from 'react-select'
import { useTheme } from 'emotion-theming'
import styled from '@emotion/styled'

// icon
import { TriangleVertical } from 'components/ui/icons/Triangle'

// components
import { TitleCaps } from 'components/SelectRelations/MenuContent'

const themeSelectDropdownWhite = ({ projectTheme }) => {
  return {
    control: {
      color: projectTheme.blueElectric,
      background: projectTheme.white
    },
    menu: {
      marginTop: -8,
      borderRadius: 5,
      border: `1px solid ${projectTheme.blueElectricLighter}`
    }
  }
}

const customStyles = {
  singleValue: () => ({
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: '0.1em',
    textTransform: 'uppercase'
  }),
  control: (_, { menuIsOpen, selectProps: { projectTheme, customTheme } }) => ({
    display: 'flex',
    padding: '0 20px',
    border: 'none',
    color: menuIsOpen ? projectTheme.blueElectric : projectTheme.white,
    background: menuIsOpen ? projectTheme.white : projectTheme.blueMedium,
    ...(customTheme && customTheme({ menuIsOpen, projectTheme }).control)
  }),
  menu: (provided, { menuIsOpen, selectProps: { projectTheme, customTheme } }) => ({
    ...provided,
    marginTop: 0,
    marginBottom: 0,
    boxShadow: 'none',
    whiteSpace: 'nowrap',
    width: 'auto',
    padding: '20px 30px 20px 0',
    cursor: 'auto',
    zIndex: 999,
    borderRadius: '2px 2px 0 0',
    ...(customTheme && customTheme({ menuIsOpen, projectTheme }).menu)
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: 'none'
  }),
  container: () => ({
    position: 'relative',
    display: 'flex',
    cursor: 'pointer'
  }),
  indicatorsContainer: () => ({
    display: 'flex',
    alignItems: 'center'
  }),
  indicatorSeparator: () => { },
  option: (_, { isSelected, selectProps: { projectTheme } }) => ({
    borderLeft: `5px solid ${isSelected ? projectTheme.tonic : projectTheme.white}`,
    fontWeight: isSelected ? 700 : 500,
    color: projectTheme.blueElectric,
    padding: '0 0 0 25px',
    fontSize: 13,
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    ':hover': {
      borderLeft: `5px solid ${projectTheme.tonic}`
    }
  })
}

const GroupLabel = styled(TitleCaps)`
  padding-left: 9px;
`

const formatGroupLabel = data => {
  return data.label
    ? (
      <GroupLabel>
        {data.label}
      </GroupLabel>
    )
    : null
}

const DropdownIndicator = ({ innerRef, selectProps: { menuIsOpen } }) => (
  <TriangleVertical ref={innerRef} isActive={menuIsOpen} />
)

const OptionDefault = props => {
  const { data: { tooltip } } = props
  return (
    <div title={tooltip}>
      <components.Option {...props}>
        {props.children}
      </components.Option>
    </div>
  )
}

const SelectDropdown = (props) => {
  const { onChange } = props

  const projectTheme = useTheme()
  const customComponents = {
    DropdownIndicator,
    Option: props.customOption || OptionDefault
  }

  const onChangeFn = useCallback((d) => {
    onChange(d.value)
  }, [onChange])

  return (
    <Select
      options={props.options}
      menuPlacement='auto'
      projectTheme={projectTheme}
      customTheme={props.customTheme}
      styles={customStyles}
      value={props.selected}
      onChange={onChangeFn}
      formatGroupLabel={formatGroupLabel}
      components={customComponents}
      isSearchable={false}
    />
  )
}

export default SelectDropdown
export { themeSelectDropdownWhite }
